<template>
  <div class="header-view-component">
    <header :class="{ fix: isHeaderFixed }">
      <div class="header">
        <div class="box flex between">
          <h1 class="self zindex-999">
            <router-link to="/"><img style="max-width: 80%; width: 200px" src="/images/waykar_logo.png" alt="Waykar Logo"/></router-link>
          </h1>
          <nav class="self">
            <ul class="flex between self">
              <li :class="{ active: $route.path === '/' }">
                <router-link to="/">首页</router-link>
              </li>
              <li :class="{ active: $route.path === '/about' }">
                <router-link to="/about">关于Waykar</router-link>
              </li>
              <li
                  :class="{ active: $route.path === '/product' || isProductDropdownOpen }"
                  @mouseenter="isProductDropdownOpen = true"
                  @mouseleave="isProductDropdownOpen = false"
              >
                <router-link to="/product">产品</router-link>
                <transition name="dropdown-fade" appear>
                  <div class="Pop zindex-0" v-show="isProductDropdownOpen">
                    <div class="Nav">
                      <div class="flex">
                        <div class="NavBg">
                          <dl>
                            <dt><img src="/wimages/100.png" alt=""/></dt>
                          </dl>
                          <div class="ClickOne">
                            <div class="Click">
                              <!-- 增加加载状态判断 -->
                              <p v-if="isLoading">加载中...</p>
                              <p
                                  v-for="(category, index) in productNavCategories"
                                  :key="category.name"
                                  :class="{ Active: activeProductCategoryIndex === index }"
                                  @mouseenter="handleCategorySwitch(index)"
                                  @click="navigateToCategory(category.id)"
                              >
                                {{ category.name }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="NavList">
                          <div class="NavShow">
                            <transition-group name="product-slide" tag="div" class="product-container">
                              <div
                                  class="One"
                                  v-for="(category, catIndex) in productNavCategories"
                                  :key="'cat-' + catIndex"
                                  :class="{ Active: activeProductCategoryIndex === catIndex }"
                                  v-show="activeProductCategoryIndex === catIndex"
                              >
                                <!-- 增加加载状态判断 -->
                                <p v-if="isLoading">加载中...</p>
                                <router-link
                                    v-for="(product, prodIndex) in category.products"
                                    :key="'prod-' + prodIndex"
                                    :to="product.link"
                                    class="product-item"
                                    :style="{ animationDelay: (prodIndex * 0.1) + 's' }"
                                >
                                  <span>
                                    <img :src="product.img_url"  alt=""/>
                                  </span>
                                  <p>{{ product.name }}</p>
                                </router-link>
                              </div>
                            </transition-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </li>
              <li :class="{ active: $route.path === '/solutions' }">
                <router-link to="/solutions">客户案例</router-link>
              </li>
              <li :class="{ active: $route.path === '/news' }">
                <router-link to="/news">新闻动态</router-link>
              </li>
              <li :class="{ active: $route.path === '/service' }">
                <router-link to="/service">服务</router-link>
              </li>
              <li :class="{ active: $route.path === '/contact' }">
                <router-link to="/contact">联系我们</router-link>
              </li>
<!--              <li :class="{ active: $route.path === '/csr' }">-->
<!--                <router-link to="/csr">社会责任</router-link>-->
<!--              </li>-->
            </ul>
          </nav>
          <div class="HeadTel flex between self zindex-999">
            <dl>
              <dt><img src="/images/u63.png" alt=""/></dt>
              <dd>{{ settings.contactNumber }}</dd>
            </dl>
          </div>
          <div class="wap_nav self wap_show" @click="toggleMobileNav">
            <span :class="{ 'first-rotate': isMobileNavOpen }"></span>
            <span :class="{ 'mid-width': isMobileNavOpen }"></span>
            <span :class="{ 'last-rotate': isMobileNavOpen }"></span>
          </div>
          <!-- 移动端导航 -->
          <div class="mobile-nav" v-if="isMobileNavOpen">
            <ul>
              <li :class="{ active: $route.path === '/' }">
                <router-link to="/" @click="closeMobileNav">首页</router-link>
              </li>
              <li :class="{ active: $route.path === '/about' }">
                <router-link to="/about" @click="closeMobileNav">关于Waykar</router-link>
              </li>
              <li :class="{ active: $route.path === '/product' || activeMobileNavItem === 0 }">
                <router-link to="/product" @click="toggleMobileMainMenu(0)">产品</router-link>
                <div class="mobile-sub" v-if="activeMobileNavItem === 0">
                  <div class="mobile-sub-menu">
                    <div class="mobile-sub-item" v-for="(category, catIndex) in productNavCategories"
                         :key="category.name">
                      <div class="mobile-sub-header" @click="toggleMobileAccordion(catIndex)">
                        {{ category.name }}
                        <span>
                          <!-- 移除对未定义变量 product.img_url 的引用 -->
                        </span>
                      </div>
                      <div class="mobile-sub2" v-if="mobileAccordionOpen[catIndex]">
                        <router-link
                            v-for="product in category.products"
                            :key="product.name"
                            :to="product.link"
                            @click="closeMobileNav"
                        >
                          {{ product.name }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="{ active: $route.path === '/case_studies' }">
                <router-link to="/solutions" @click="closeMobileNav">客户案例</router-link>
              </li>
              <li :class="{ active: $route.path === '/news' }">
                <router-link to="/news" @click="closeMobileNav">新闻动态</router-link>
              </li>
              <li :class="{ active: $route.path === '/service' }">
                <router-link to="/service" @click="closeMobileNav">服务</router-link>
              </li>
              <li :class="{ active: $route.path === '/contact' }">
                <router-link to="/contact" @click="closeMobileNav">联系我们</router-link>
              </li>
<!--              <li :class="{ active: $route.path === '/csr' }">-->
<!--                <router-link to="/csr" @click="closeMobileNav">社会责任</router-link>-->
<!--              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import {getSetting} from '@/api/request';
import {getProductsCategory, getProductList} from '@/api/request.js';

export default {
  name: 'HeaderView',
  data() {
    return {
      isMobileNavOpen: false,
      isHeaderFixed: false,
      // For Desktop Product Dropdown
      isProductDropdownOpen: false,
      activeProductCategoryIndex: 0, // Default to first category
      isAnimating: false, // 防止动画期间快速切换
      productNavCategories: [], // 初始化为空数组
      // For Mobile Navigation
      activeMobileNavItem: null, // Index of the currently open main mobile nav item (0 for 产品服务, 1 for 解决方案)
      mobileAccordionOpen: [false, false, false, false], // For sub-category accordions within mobile nav
      settings: {
        contactNumber: ''
      },
      // 新增 loading 状态
      isLoading: true,
    };
  },
  methods: {
    fetchSettings() {
      getSetting().then(response => {
        const settingsData = response.list;
        this.settings.contactNumber = this.findSetting(settingsData, '联系方式').value_string;
      });
    },
    findSetting(settings, name) {
      return settings.find(setting => setting.name === name) || {};
    },
    toggleMobileNav() {
      this.isMobileNavOpen = !this.isMobileNavOpen;
      document.body.classList.toggle('fix', this.isMobileNavOpen);
      if (!this.isMobileNavOpen) {
        // Reset sub-menus when closing main mobile nav
        this.activeMobileNavItem = null;
        this.mobileAccordionOpen = this.mobileAccordionOpen.map(() => false);
      }
    },
    closeMobileNav() {
      this.isMobileNavOpen = false;
      document.body.classList.remove('fix');
      this.activeMobileNavItem = null;
      this.mobileAccordionOpen = this.mobileAccordionOpen.map(() => false);
    },
    // For Mobile Main Menu Items (e.g., 产品服务, 解决方案)
    toggleMobileMainMenu(index) {
      // If clicking the already active main menu, or if no sub-items, close it
      if (this.activeMobileNavItem === index) {
        this.activeMobileNavItem = null; // Toggle off
        this.mobileAccordionOpen = this.mobileAccordionOpen.map(() => false); // Close all accordions
      } else {
        this.activeMobileNavItem = index;
        this.mobileAccordionOpen = this.mobileAccordionOpen.map(() => false); // Close all accordions when switching main category
      }
    },
    // For accordions within a mobile main menu item (e.g., 智能售前)
    toggleMobileAccordion(accordionIndex) {
      // Toggle the specific accordion, keep others as they are or close them
      // This simple toggle works if you only want one accordion open at a time within a category
      const currentState = this.mobileAccordionOpen[accordionIndex];
      this.mobileAccordionOpen = this.mobileAccordionOpen.map(() => false); // Close all
      this.mobileAccordionOpen[accordionIndex] = !currentState; // Toggle the clicked one
    },
    showDemoModal() {
      // Implement modal logic here
    },
    handleScroll() {
      // 当滚动超过一定距离时添加固定样式（阴影等）
      this.isHeaderFixed = window.scrollY > 50;
    },
    navigateTo(path) {
      this.$router.push(path);
      this.closeMobileNav();
    },
    // 处理产品分类切换动画
    handleCategorySwitch(index) {
      if (this.isAnimating || this.activeProductCategoryIndex === index) {
        return;
      }

      this.isAnimating = true;
      this.activeProductCategoryIndex = index;

      // 重置产品项目动画
      this.$nextTick(() => {
        const productItems = this.$el.querySelectorAll('.header-view-component .Pop .NavList .product-item');
        productItems.forEach((item, idx) => {
          item.style.animationDelay = (idx * 0.1) + 's';
          item.style.animation = 'none';
          // 强制重绘
          item.offsetHeight;
          item.style.animation = 'productFadeIn 0.6s cubic-bezier(0.45, 0.8, 0.45, 1) both';
        });

        setTimeout(() => {
          this.isAnimating = false;
        }, 600);
      });
    },
    
    // 跳转到指定分类的产品列表页面
    navigateToCategory(categoryId) {
      // 关闭下拉菜单
      this.isProductDropdownOpen = false;
      // 跳转到产品列表页面，并传递分类ID作为路由参数
      this.$router.push(`/product_list/${categoryId}`);
    },

    // 新增方法：获取产品分类
    async fetchProductCategories() {
      try {
        const response = await getProductsCategory({parent_id: 1});
        if (response && Array.isArray(response.list)) {
          this.productNavCategories = response.list.map(category => ({
            name: category.name || '未知分类',
            id: category.id,
            products: [] // 初始为空，后续填充产品数据
          }));
          console.log('分类加载成功:', this.productNavCategories);
          await this.fetchProductLists();
        } else {
          console.warn('Invalid or empty categories in the response:', response);
          this.productNavCategories = [
            {name: '默认分类', id: 0, products: [{name: '默认产品', link: '#', iconClass: ''}]}
          ];
        }
        console.log(this.productNavCategories, 11111111111111)
      } catch (error) {
        console.error('Failed to fetch product categories:', error);
        this.productNavCategories = [
          {name: '默认分类', id: 0, products: [{name: '默认产品', link: '#', iconClass: ''}]}
        ];
      } finally {
        this.isLoading = false;
      }
    },

    // 新增方法：根据分类ID获取产品列表

    async fetchProductLists() {
      try {
        for (let i = 0; i < this.productNavCategories.length; i++) {
          const categoryId = this.productNavCategories[i].id;
          const response = await getProductList({category_id: categoryId});
          if (response && Array.isArray(response.list)) {
            this.productNavCategories[i].products = response.list.map(product => ({
              name: product.name || '未知产品',
              img_url: product.cover_image_url,
              link: `/product_list/${product.category_id}?productId=${product.id}` || '#',
            }));
          } else {
            console.warn(`No products found for category ID ${categoryId}:`, response);
            this.productNavCategories[i].products = [{name: '默认产品', link: '#', iconClass: ''}];
          }
        }
      } catch (error) {
        console.error('Failed to fetch product lists:', error);
        this.productNavCategories.forEach(category => {
          category.products = [{name: '默认产品', link: '#', iconClass: ''}];
        });
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    '$route'() {
      this.closeMobileNav();
    },
    isProductDropdownOpen(isHovering) {
      if (isHovering) {
        this.activeProductCategoryIndex = 0;
      }
    }
  },
  mounted() {
    this.fetchSettings();
    window.addEventListener('scroll', this.handleScroll);

    // 调用新方法获取产品分类和产品列表
    this.fetchProductCategories();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.isMobileNavOpen) {
      document.body.classList.remove('fix');
    }
  }
}
</script>

<style>
/* HeaderView 组件样式 - 确保header固定效果 */
.header-view-component header {
  position: sticky !important;
  top: 0 !important;
  z-index: 99999 !important;
  width: 100% !important;
  background: #fff !important;
  transition: all 0.3s cubic-bezier(0.45, 0.8, 0.45, 1) !important;
  padding: 5px 0 !important;
  border-bottom: 1px rgba(455, 455, 455, .38) solid !important;
}

/* 滚动时的阴影效果 */
.header-view-component header.fix {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  background: rgba(455, 455, 455, 0.95) !important;
}

/* Ensure .Pop is positioned correctly if you manage its display with v-show */
header nav ul li .Pop {
  position: absolute;
  /* Other styles from your original CSS for .Pop */
}

/* 下拉菜单主容器动画 */
.dropdown-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.45, 0.8, 0.45, 1);
}

.dropdown-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.45, 0.8, 0.45, 1);
}

.dropdown-fade-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 产品容器样式 */
.product-container {
  position: relative;
  overflow: hidden;
}

/* 产品分类切换动画 */
.product-slide-enter-active {
  transition: all 0.5s cubic-bezier(0.45, 0.8, 0.45, 1);
}

.product-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.45, 0.8, 0.45, 1);
}

.product-slide-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.product-slide-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* 产品项目样式 - 限制在下拉菜单内 */
.header-view-component .Pop .NavList .product-item {
  display: inline-block !important;
  animation: productFadeIn 0.6s cubic-bezier(0.45, 0.8, 0.45, 1) both !important;
  animation-play-state: running !important;
  transition: all 0.3s cubic-bezier(0.45, 0.8, 0.45, 1) !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  padding: 10px 0px;
}

.header-view-component .Pop .NavList .product-item:hover {
  transform: translateY(-5px) scale(1.02) !important;
  box-shadow: 0 10px 45px rgba(0, 0, 0, 0.1) !important;
}

/* 确保其他地方的链接不受影响 */
.header-view-component h1 a,
.header-view-component .HeadTel a,
.header-view-component nav a:not(.product-item) {
  animation: none !important;
  transition: color 0.3s ease !important;
}

@keyframes productFadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 优化下拉菜单的阴影效果 */
.Pop {
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

/* 为整个下拉菜单添加背景模糊效果 */
.Pop::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(455, 455, 455, 0.95);
  backdrop-filter: blur(10px);
  z-index: -1;
}

/* 确保内容在模糊背景之上 */
.Pop .Nav {
  position: relative;
  z-index: 1;
}

/* Styles for the hamburger animation if not already global */
.wap_nav span {
  display: block;
  width: 45px;
  height: 2px;
  margin-bottom: 5px;
  background-color: #47975a; /* Or your theme color */
  transition: background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
  opacity 0.55s ease,
  transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
  width 0.5s;
  transform-origin: 1px center; /* Adjusted for typical hamburger icon */
  border-radius: 3px;
}

.wap_nav span:last-child {
  margin-bottom: 0;
}

.wap_nav span.first-rotate {
  transform: rotate(45deg) translate(3px, -3px); /* Adjust translation for better alignment */
}

.wap_nav span.mid-width {
  width: 0;
  opacity: 0;
}

.wap_nav span.last-rotate {
  transform: rotate(-45deg) translate(4px, 2px); /* Adjust translation for better alignment */
}

/* Mobile navigation visibility */
.wap_nav_sw_nav.header-show {
  display: block !important; /* Or flex, depending on your layout */
}

/* Accordion arrow rotation */
dl.Active > dt.wapck img {
  transform: rotate(-180deg);
}

dt.wapck img {
  transition: transform 0.3s ease;
}
.One{
  margin-left: 24px;
}

@media screen and (max-width: 768px) {
  .One {
    margin-left: 0;
  }
}
</style>